import { render, staticRenderFns } from "./leaderboard_criteria.vue?vue&type=template&id=70486616&scoped=true"
import script from "./leaderboard_criteria.vue?vue&type=script&lang=ts&setup=true"
export * from "./leaderboard_criteria.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./leaderboard_criteria.vue?vue&type=style&index=0&id=70486616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70486616",
  null
  
)

export default component.exports